// @ts-nocheck
import axios from 'axios';

import API_ENDPOINTS from '../../const/ApiEndPoints';

export default function useTask() {
  const getPendingTasks = (body, loader = false) => {
    return axios
      .get(
        `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.DB.GET_PENDING_TASKS}`,
        { params: body, loader }
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  };
  const getTaskQueue = (body, loader = false) => {
    return axios
      .get(
        `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.DB.GET_TASK_QUEUE}`,
        { params: body, loader: loader }
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  };
  const getTaskQueueFilter = (body) => {
    return axios
      .get(
        `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.DB.GET_TASK_QUEUE_FILTER}`,
        { params: body }
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  };
  const getTaskResult = (params) => {
    return axios
      .get(
        `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.DB.GET_TASK_RESULT}`,
        { params }
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  };
  const getOpenTasks = (body, loader = false) => {
    return axios
      .get(
        `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.DB.GET_OPEN_TASKS}`,
        { params: body, loader }
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  };
  const retriggerAutomation = (body) => {
    return axios
      .post(
        `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.AUT.RETRIGGER_AUTOMATION}`,
        body
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  };

  return {
    getPendingTasks,
    getOpenTasks,
    getTaskQueue,
    getTaskResult,
    getTaskQueueFilter,
    retriggerAutomation,
  };
}
